import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — combina classes Tailwind sem conflito.
 * Padrão shadcn/ui: clsx (condicionais) + tailwind-merge (dedup).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
